import { createActionCreator } from '../../lib/Actions';

const createAction = createActionCreator('PAGINATED_ITEMS');
/**
 * url is the key. If fetchUrl is not present, url is also fetchUrl (that is, url will be used
 * for fetching)
 */
// eslint-disable-next-line
export const FETCH = createAction('FETCH', ({ url, fetchUrl, isInfinitePagination }) =>
  ({ url, fetchUrl, isInfinitePagination }));
